import React from 'react';
import styled from 'styled-components';
import { smallMediaQuery } from '../../../../common/utilities/sizeHelpers';

export const WeekendStartEnd = () => {
    return (
        <Container>
            <WeekendIndicator />
        </Container>
    );
};

const Container = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 247px;
    width: 43.5px;
    margin-right: 1.5px;
    @media ${smallMediaQuery} {
        flex-direction: row;
        width: 100%;
        height: 13px;
        margin-right: 0px;
        margin-bottom: 5px;
    }
`;

const WeekendIndicator = styled.div`
    display: inline-block;
    content: '';
    width: 9px;
    height: 9px;
    border-radius: 100%;
    background-color: rgba(255,255,255,0.5);
    @media ${smallMediaQuery} {
        width: 7px;
        height: 7px;
    }
`;